export default __webpack_public_path__ + "static/media/2.ccca24a8.svg";